function slugifyPreviewName(name) {
  const slug = String(name || '')
    .normalize('NFKD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, 48)
    .replace(/-+$/, '');

  return slug || 'site';
}

function isValidPreviewSlug(slug) {
  return /^[a-z0-9](?:[a-z0-9-]{0,48}[a-z0-9])?$/.test(slug);
}

function previewHostname(site, previewDomain = 'preview.spache.online') {
  return `${site.previewSlug || site.id}.${previewDomain}`;
}

function isPreviewHostname(hostname, previewDomain = 'preview.spache.online') {
  const host = String(hostname || '').split(':')[0].toLowerCase();
  const suffix = `.${previewDomain.toLowerCase()}`;
  return host.endsWith(suffix) && host.length > suffix.length;
}

module.exports = {
  isPreviewHostname,
  isValidPreviewSlug,
  previewHostname,
  slugifyPreviewName
};
